import { type GetImpersonationTokenApiResponse } from '../store/skeletor/users/getImpersonationToken/api.types';

const ENDPOINT = (userId: string) =>
  `${window.location.origin}${import.meta.env.VITE_BASE_API_URI}/users/${userId}/impersonation-token`;

const refreshImpersonateToken = async ({
  accessToken,
  idToken,
  userId,
}: {
  userId: string;
  accessToken: string;
  idToken: string;
}) => {
  const response = await fetch(ENDPOINT(userId), {
    method: 'GET',
    headers: {
      authorization: `Bearer ${accessToken}`,
      'x-id-token': `${idToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(
      `Failed to refresh impersonation token: ${response.status}`,
    );
  }

  const { data } = (await response.json()) as GetImpersonationTokenApiResponse;

  return data.token;
};

export { refreshImpersonateToken };
